var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 7.08464C11.6667 4.78345 9.80121 2.91797 7.50004 2.91797C5.19886 2.91797 3.33337 4.78345 3.33337 7.08464C3.33337 9.3858 5.19886 11.2513 7.50004 11.2513C9.80121 11.2513 11.6667 9.3858 11.6667 7.08464Z",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 17.0833C13.3333 13.8617 10.7216 11.25 7.49996 11.25C4.2783 11.25 1.66663 13.8617 1.66663 17.0833",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8334 7.5V12.5M18.3334 10H13.3334",
    stroke: "#464255",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestBlack);
export default __webpack_public_path__ + "static/media/request-black.fdfda2f3e56b3af91c1770e9c27f30ff.svg";
export { ForwardRef as ReactComponent };